export default "__VITE_ASSET__BbmY60WE__"